// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.value[data-v-74b9dee0] {\n  font-weight: 600;\n  font-size: 24px;\n  color: #212529;\n}\n.area-cards-info[data-v-74b9dee0]:not(:first-child) {\n  /* border-top: 1px solid #dee2e6; */\n  padding: 24px 0 15px 0;\n}\n.area-cards-info[data-v-74b9dee0]:first-child {\n  padding-bottom: 24px;\n}\n.area-cards-info[data-v-74b9dee0] {\n  /* padding: 24px 0; */\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
